import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Select from 'react-select';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const TrainingOrganizer = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	const [roledata, setRoleData] = useState([]);
	const [noduedepartmentdata, setNoduedepartmentData] = useState([]);
	// const [item1, setItem]= useState([]);
	const [dataval, setDataVal] = useState([]);
	const [isVisible, setIsVisible] = useState(false);

	



	const [user, setUser] = useState({
    emp_id: [],
});


	const handleEmployees = async () => {
	  
        	axios.get(API_BASE_URL + '/all_regular_employees', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
   
         .then(res1 => setDataVal(res1.data))
         .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleEmployees();
      }, []);

	  const handelInput = (event) => {
        // event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }


	const options = [
  { value: "ALL", label: "All Employee" },
  ...(dataval || []).map(option => ({
    value: option.user_id,
    label: `${option.first_name} ${option.last_name} ${option.employee_id}`
  }))
];



const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation
  if (!user.emp_id || user.emp_id.length === 0) {
    toast.error("Please select at least one employee");
    return;
  }

  try {
    const response = await axios.post(
      API_BASE_URL + "/storetraining_organizer",
      {
        emp_id: user.emp_id.map(item => item.value), // send only IDs
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    toast.success(response.data.message);

  } catch (error) {
    if (error.response && error.response.data.errors) {
      Object.values(error.response.data.errors).forEach(err => {
        toast.error(err[0]);
      });
    } else {
      toast.error("Something went wrong");
    }
  }
};



const fetchTrainingOrganizer = async () => {
  try {
    const res = await axios.get(
      API_BASE_URL + "/gettraining_organizer",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    const storedIds = res.data.training_organizer || [];

    // Convert stored IDs to react-select format
    const selectedOptions = (dataval || [])
      .filter(emp => storedIds.includes(String(emp.user_id)))
      .map(emp => ({
        value: emp.user_id,
        label: `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
      }));

    setUser(prev => ({
      ...prev,
      emp_id: selectedOptions
    }));

  } catch (err) {
    console.log(err);
  }
};


useEffect(() => {
  const loadData = async () => {
    await handleEmployees();
  };
  loadData();
}, []);

useEffect(() => {
  if (dataval.length > 0) {
    fetchTrainingOrganizer();
  }
}, [dataval]);

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">Training Organizer </h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										</div>
										<div className="card-body">

											<form onSubmit={handleSubmit}>
												
												
															<div>


																<div className="col-md-6">
  <div className="form-group mb-3">
    <Select
      isMulti
      options={[
        { value: "ALL", label: "All Employee" },
        ...(dataval || []).map(emp => ({
          value: emp.user_id,
          label: `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
        }))
      ]}
      isSearchable
      placeholder="Select Employee(s)"
      value={user.emp_id}
      onChange={(selected) =>
        setUser({
          ...user,
          emp_id: selected || []
        })
      }
    />
  </div>
</div>





															</div>


														



													
												

												{/* <div className="body"> {JSON.stringify(users)} </div> */}

												<div class="row">

													{/* <div className="body"> {JSON.stringify(item)} </div>  */}

													<div className="col-md-6">
  <div className="form-group mt-3">
    <button type="submit" className="btn btn-primary">
      Add Training Organizer
    </button>
  </div>
</div>


												</div>
											</form>




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(TrainingOrganizer);